module.exports = __webpack_public_path__ + "img/Metastasis-MELA_GSE185386.045e8f97.png";